<div class="auth-flex-columns">
  <div class="auth-inner-wrapper min-height">
    <img (click)="closeDialog()" class="close-icon" src="./../../../../assets/images/icons/close.svg" alt="close-icon">
    <div class="form-block">
      <div class="heading">
        <h1 class="page-title">Verify your email</h1>
        <img class="description-img" src="./../../../../assets/images/auth/success.svg" alt="registration-success">
        <p class="auth-page-description success">We've sent you a confirmation link to:
          <b>{{email}}</b>.<br />Check your email to proceed to the final step of the registration.</p>
      </div>
      <form>
        <div class="extra-links">
          <p class="line">
            <span>Go back to <a (click)="openLoginDialog()">Sign in</a></span>
          </p>
        </div>

      </form>
    </div>
  </div>
  <div class="banner-container">
    <app-current-banner [minWidth]="380" [authDialogStyles]="true"></app-current-banner>
  </div>

</div>
